module.exports = __webpack_public_path__ + "img/chat-ai-white.c7b8eca3.png";